import { Tag } from '@ads/components-react';
import { useTranslation } from 'react-i18next';

import type { DocumentationStatus } from '../../../types/enrollment';

const STATUS_MAP: Record<DocumentationStatus, 'positive' | 'helper' | 'negative' | 'default'> = {
  pending: 'helper',
  approved_temporary: 'helper',
  approved: 'positive',
  rejected: 'negative',
  not_sent: 'default',
};

interface DocumentationStatusBadgeProps {
  readonly status: DocumentationStatus;
}

export function DocumentationStatusBadge({ status }: DocumentationStatusBadgeProps) {
  const { t } = useTranslation('personManagement');
  return (
    <Tag
      label={t(`documentationStatus.${status}`)}
      size="md"
      status={STATUS_MAP[status]}
      custom={{ text: 'text-nowrap' }}
    />
  );
}
